import { request } from "@/api/client";
import type { EmailStatus } from "@/types/email";

export type EmailImapTestPayload = {
  email_address: string;
  imap_host: string;
  imap_port?: number;
  use_ssl?: boolean;
  username: string;
  password: string;
};

export function testImap(payload?: EmailImapTestPayload) {
  return request<EmailStatus>("/email/test_imap", {
    method: "POST",
    body: payload,
  });
}

export function disconnectImap() {
  return request<void>("/email/integration", {
    method: "DELETE",
  });
}

export type EmailSenderScope = "default" | "artist";

export type EmailSenderAccount = {
  configured: boolean;
  id: string | null;
  scope: EmailSenderScope;
  artist_id: string | null;
  email_address: string | null;
  from_name: string | null;
  reply_to: string | null;
  smtp_host: string | null;
  smtp_port: number | null;
  smtp_security: "starttls" | "tls" | null;
  smtp_username: string | null;
  enabled: boolean;
  verification_status: string;
  last_verified_at: string | null;
  last_error_code: string | null;
  effective_source: EmailSenderScope | null;
};

export type EmailSenderInput = {
  email_address: string;
  from_name?: string | null;
  reply_to?: string | null;
  smtp_host: string;
  smtp_port: number;
  smtp_security: "starttls" | "tls";
  smtp_username: string;
  password?: string;
  enabled: boolean;
};

export function fetchEmailSender(scope: EmailSenderScope) {
  return request<EmailSenderAccount>(`/email-senders/${scope}`);
}

export function saveEmailSender(scope: EmailSenderScope, payload: EmailSenderInput) {
  return request<EmailSenderAccount>(`/email-senders/${scope}`, { method: "PUT", body: payload });
}

export function deleteEmailSender(scope: EmailSenderScope) {
  return request<void>(`/email-senders/${scope}`, { method: "DELETE" });
}

export function fetchEffectiveEmailSender() {
  return request<EmailSenderAccount>("/email-senders/effective");
}
